import "./index.scss";

const DeleteClient = ({
  deleteClientDetails,
  handleDeleteCancel,
  handleDeleteConfirm,
}) => {
  return (
    <div className="delete-client-modal">
      <div className="delete-client-modal__header">
        <h2>Delete Client</h2>
      </div>

      <div className="delete-client-modal__body">
        <p className="delete-client-modal__message">
          Are you sure you want to delete this client?
        </p>
        <div className="delete-client-modal__details">
          <p>
            <strong>Client Name:</strong> {deleteClientDetails?.client_name}
          </p>
          <p>
            <strong>Client ID:</strong> {deleteClientDetails?.client_id}
          </p>
          <p>
            <strong>Current CD Balance:</strong> {deleteClientDetails?.currency}{" "}
            {deleteClientDetails?.current_cd_balance?.toLocaleString()}
          </p>
        </div>
        <p className="delete-client-modal__warning">
          This action cannot be undone.
        </p>
      </div>

      <div className="delete-client-modal__actions">
        <button
          onClick={handleDeleteCancel}
          className="delete-client-modal__button delete-client-modal__button--secondary"
        >
          Cancel
        </button>
        <button
          onClick={handleDeleteConfirm}
          className="delete-client-modal__button delete-client-modal__button--danger"
        >
          Delete Client
        </button>
      </div>
    </div>
  );
};

export default DeleteClient;
